import React from "react";

const DebitNotes = () => {
  return <div>Debit note is under construction ⚒️...</div>;
};

export default DebitNotes;
